import { GET_TIMES, GET_TIMES_ERROR, GET_TIMES_SUCCESS, GET_TIMES_GROUP, GET_TIMES_GROUP_ERROR, GET_TIMES_GROUP_SUCCESS } from './Times.actions';

const initial = {
  data: [], // Times
  data_group: [], // Times Group
  loadingTimes: false,
  errorTimes: undefined,
  loadingTimesGroup: false,
  errorTimesGroup: undefined,
};

const timesReducer = (state = initial, { payload, type }) => {
  switch (type) {
    /* TIMES */
    case GET_TIMES:
      return { ...state, loadingTimes: true, errorTimes: undefined };
    case GET_TIMES_ERROR:
      return { ...state, loadingTimes: false, errorTimes: payload.error };
    case GET_TIMES_SUCCESS:
      return {
        ...state,
        loadingTimes: false,
        errorTimes: undefined,
        data: payload.data,
      };
    /* TIMES GROUP*/
    case GET_TIMES_GROUP:
      return { ...state, loadingTimesGroup: true, errorTimesGroup: undefined };
    case GET_TIMES_GROUP_ERROR:
      return { ...state, loadingTimesGroup: false, errorTimesGroup: payload.error };
    case GET_TIMES_GROUP_SUCCESS:
      return {
        ...state,
        loadingTimesGroup: false,
        errorTimesGroup: undefined,
        data_group: payload.data,
      };

    default:
      return state;
  }
};

export default timesReducer;
